export const Separator = () => {
  return <div className="border-[#F4F4F6] border-t-[2px] my-4"></div>;
};
